@let isError = isRequired() && (!customFormControl()?.valid && customFormControl()?.touched);
@let isFilled = customFormControl()?.valid && customFormControl()?.value?.length ;

<div class="d-flex justify-content-start align-items-center">
    <label  class="naps-label" >{{label()}}</label>@if(isRequired()){<sup class="naps-text-error">*</sup>}
</div>
<mat-form-field id="naps-date-picker" class="w-100"
[ngClass]="{
    'naps-disabled': disabledField(),
    'naps-error': isError
  }" >
    <input matInput [min]="minDate" [max]="maxDate"
    [formControl]="customFormControl()" placeholder="MM-DD-YYYY"
    (dateInput)="handleDateChange($event)" (dateChange)="handleDateChange($event)"
     [matDatepicker]="picker" readonly>
    <mat-hint [class.nsdc-text-error]="isError" >
        <ng-content>
            @if(isError){
                Please Fill Date in This Format DD/MM/YY
            }
        </ng-content>
    </mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon
        [ngClass]="{
            'naps-filled': isFilled,
            'naps-error': isError
          }">
            <i class="sd sd-calendar" ></i>
        </mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker [disabled]="disabledField()"   #picker [calendarHeaderComponent]="customHeader"></mat-datepicker>
  </mat-form-field>